import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { UpdateVersionComponent } from '../../_components/update-version-modal/update-version/update-version.component';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private swUpdate = inject(SwUpdate);
  private dialog = inject(MatDialog);

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent =>
            event.type === 'VERSION_READY'
        )
      )
      .subscribe(() => {
        this.showUpdateDialog();
      });
  }

  private showUpdateDialog(): void {
    const dialogRef = this.dialog.open(UpdateVersionComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        window.location.reload(); // Reload the page if the user confirms
      }
    });
  }
}